import React from 'react';
import { connect, ConnectedProps } from '@cerebral/react';
import { state, sequences } from 'app/pwa/app.cerebral';

import Lab122 from 'dc/Lab122';
import { Wrapper, LoaderWrapper, Image } from './elements';
import Load02 from 'dc/Load02';
import BasicInfo from './BasicInfo';
import MoreInfo from './MoreInfo';
import LazyImage from 'common/components/LazyImage';
import { ICON } from 'resources/constants';

const deps = {
  campaignImage: state.challenge.campaign.image,
  sponsors: state.challenge.campaign.sponsors,
  moreInfoExpanded: state.challenge.info.moreInfoExpanded,
  toggleMoreInfoClicked: sequences`challenge.info.toggleMoreInfoClicked`,
};

export function ChallengeInfo({
  campaignImage,
  moreInfoExpanded,
  toggleMoreInfoClicked,
}: typeof deps & ConnectedProps): React.ReactElement {
  return (
    <Wrapper>
      <LazyImage
        path={campaignImage}
        onLoading={() => (
          <LoaderWrapper>
            <Load02 icon={ICON.photo} />
          </LoaderWrapper>
        )}
        onLoaded={url => <Image src={url} />}
      />
      <BasicInfo />
      {moreInfoExpanded ? <MoreInfo /> : null}
      <Lab122
        onClick={() => toggleMoreInfoClicked()}
        expanded={moreInfoExpanded}
      />
    </Wrapper>
  );
}

export default connect(deps, ChallengeInfo);
